import { render } from "./ProfileAvatar.vue?vue&type=template&id=0f5450f6&scoped=true"
import script from "./ProfileAvatar.vue?vue&type=script&lang=ts"
export * from "./ProfileAvatar.vue?vue&type=script&lang=ts"

import "./ProfileAvatar.vue?vue&type=style&index=0&id=0f5450f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0f5450f6"

export default script